import { render, staticRenderFns } from "./Feedback.vue?vue&type=template&id=7aa404bb&scoped=true&"
import script from "./Feedback.vue?vue&type=script&lang=js&"
export * from "./Feedback.vue?vue&type=script&lang=js&"
import style0 from "./Feedback.vue?vue&type=style&index=0&id=7aa404bb&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7aa404bb",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {FormWrap: require('/home/bitrix/frontend/components/sidebars/FormAside/FormWrap.vue').default})
